import { testimonials } from "@/mocks/comicData";

function Voices() {
  return (
    <section id="voices" className="bg-secondary-100 py-16 md:py-20">
      <div className="container-page">
        <div className="mx-auto mb-10 max-w-2xl text-center">
          <span className="eyebrow">
            <i className="ri-chat-heart-line"></i>
            读者口碑
          </span>
          <h2 className="section-title mt-3">他们说，快乐是会上瘾的</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            每天都在被丫头的搞笑日常治愈，来看看大家都怎么轻松看大黄丫头漫画的吧。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {testimonials.map((item) => (
            <figure
              key={item.id}
              className="flex flex-col rounded-2xl bg-background-50 p-6"
            >
              <div className="flex items-center gap-1 text-secondary-500">
                {Array.from({ length: item.star }).map((_, i) => (
                  <i key={i} className="ri-star-fill"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                “{item.text}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <img
                  src={item.avatar}
                  alt={`${item.name}的头像`}
                  className="h-11 w-11 rounded-full object-cover"
                />
                <div>
                  <div className="font-bold text-foreground-950">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Voices;